import React, { Fragment, useContext, useEffect, useState } from 'react';
import {
    Box,
    Container,
    Divider,
    IconButton,
    Input,
    InputAdornment,
    Paper,
    Typography
} from '@mui/material';
import OrganizationList from '../../components/OrganizationList';
import { RemoteControlContext } from '../../ContextProvider';
import ErrorToast from '../../components/ErrorToast';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SearchIcon from '@mui/icons-material/Search';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Devices from '../Devices/Devices';

export default function Account () {
    const { currentOrg, organizations } = useContext(RemoteControlContext);
    const [searchText, setSearchText] = useState('');
    const [filteredOrgs, setFilteredOrgs] = useState(organizations);
    const [noOrgsFound, setNoOrgsFound] = useState(null);
    const [showDevices, setShowDevices] = useState(false);

    const handleSearch = (e) => {
        const inputText = e.target.value;
        setSearchText(inputText);
        const inputLower = inputText.toLowerCase();
        setFilteredOrgs(organizations.filter((org) => org.name.toLowerCase().includes(inputLower)));
    };

    useEffect(() => {
        if (!filteredOrgs.length) {
            setNoOrgsFound('0 organizations found');
        }
    }, [filteredOrgs.length]);

    return (
        <Box variant='sidebar'>
            {currentOrg
                ? (
                    <Fragment key={currentOrg.id}>
                        <Container variant='wrapper-sidebar'>
                            <Container variant='wrapper-sidebar-left'>
                                <Typography variant='p-left'>You are managing</Typography>
                                <Typography variant='p-strong-left'>
                                    {currentOrg.name}
                                </Typography>
                            </Container>
                            <IconButton variant='logout' onClick={() => window.oktaAuth.signOut()}>
                                <PowerSettingsNewIcon size='small' />
                                <Typography variant='h1'>Log out</Typography>
                            </IconButton>
                        </Container>
                        <Divider variant='account-menu' />
                        <Container
                          variant='wrapper-sidebar-title'
                          onClick={() => setShowDevices(true)}>
                            <Typography variant='account-title'>Devices Menu</Typography>
                            <ArrowForwardIosIcon fontSize='small' />
                        </Container>
                        <Devices open={showDevices} onClose={() => setShowDevices(false)} />
                        <Divider variant='account-menu' />
                        <Container variant='wrapper-sidebar-title'>
                            <Typography variant='account-title'>Switch Location</Typography>
                        </Container>
                        <Paper variant='searchbar'>
                            <Input
                              fullWidth
                              placeholder='Search...'
                              value={searchText}
                              onChange={handleSearch}
                              variant='searchbar'
                              disableUnderline
                              endAdornment={
                                  <InputAdornment position='end'>
                                      <IconButton disabled>
                                          <SearchIcon />
                                      </IconButton>
                                  </InputAdornment>
                                }
                            />
                        </Paper>
                        {
                            !filteredOrgs.length && noOrgsFound
                                ? (
                                    <Container variant='h-center-wrapper'>
                                        <Typography>{noOrgsFound}</Typography>
                                    </Container>
                                )
                                : <OrganizationList data={filteredOrgs.length > 0 ? filteredOrgs : organizations} />
                        }
                    </Fragment>)
                : (<ErrorToast message='User lost access' severity='warning' />)}
        </Box>
    );
}
